import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';
import {ApiResponse} from '../models/api-response.model';

@Injectable({providedIn: 'root'})
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  get<T>(path: string, params?: HttpParams, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.get<ApiResponse<T>>(this.url(path), {
      params,
      headers,
    });
  }

  post<T>(path: string, body: unknown, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.post<ApiResponse<T>>(this.url(path), body, {headers});
  }

  put<T>(path: string, body: unknown, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.put<ApiResponse<T>>(this.url(path), body, {headers});
  }

  patch<T>(path: string, body?: unknown, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.patch<ApiResponse<T>>(this.url(path), body ?? {}, {headers});
  }

  delete<T>(path: string, body?: unknown, headers?: HttpHeaders): Observable<ApiResponse<T>> {
    return this.http.delete<ApiResponse<T>>(this.url(path), {
      body,
      headers,
    });
  }

  private url(path: string): string {
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
    return `${this.baseUrl}${normalizedPath}`;
  }
}
